// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__1nI5Y"};